import { db } from '../../../firebase/config';
import { collection, addDoc, query, where, getDocs, updateDoc, doc } from "firebase/firestore";

export async function generarTokenPortal(pacienteDni, pacienteNombre, pacienteEmail, turnoFecha, clinicaId) {
  if (!pacienteDni) return null;

  const token = Math.random().toString(36).substring(2) + Date.now().toString(36);

  const fechaTurno = turnoFecha?.toDate ? turnoFecha.toDate() : new Date(turnoFecha);
  const ahora = new Date();
  const fechaVencimiento = new Date(fechaTurno);
  fechaVencimiento.setDate(fechaVencimiento.getDate() + 1);
  if (fechaVencimiento <= ahora) fechaVencimiento.setDate(ahora.getDate() + 10);

  const q = query(collection(db, 'portales'), where('dni', '==', pacienteDni), where('clinicaId', '==', clinicaId));
  const existentes = await getDocs(q);

  if (!existentes.empty) {
    await updateDoc(doc(db, 'portales', existentes.docs[0].id), { token, vencimiento: fechaVencimiento, ultimaActualizacion: new Date() });
    return token;
  }

  await addDoc(collection(db, 'portales'), {
    token, dni: pacienteDni, nombre: pacienteNombre,
    email: pacienteEmail || '', clinicaId,
    vencimiento: fechaVencimiento, creadoEn: new Date(), ultimaActualizacion: new Date(),
  });

  return token;
}

export async function obtenerTokenPorDni(dni, clinicaId) {
  if (!dni || !clinicaId) return null;
  const q = query(collection(db, 'portales'), where('dni', '==', dni), where('clinicaId', '==', clinicaId));
  const snap = await getDocs(q);
  if (snap.empty) return null;
  const portal = snap.docs[0].data();
  const vencimiento = portal.vencimiento?.toDate ? portal.vencimiento.toDate() : new Date(portal.vencimiento);
  if (vencimiento < new Date()) return null;
  return portal.token;
}